import React from 'react';
import { Row, Col, Space } from 'antd';
import StoryPresenter from '../StoryPresenter';
import ImageLoader from '../ImageLoader';

function StoryWithImage({ 
  fieldKey, imagePosition, hasImages, realmObjectID, realmObject 
}) {
  switch (imagePosition) {
    case 'top':
      return (
        <Space direction="vertical" style={{ width: '100%' }}>
          {hasImages && <ImageLoader key={realmObjectID} realmObject={realmObject} />}
          <StoryPresenter fieldKey={fieldKey} />
        </Space>
      );
    case 'bottom':
      return (
        <Space direction="vertical" style={{ width: '100%' }}>
          <StoryPresenter fieldKey={fieldKey} />
          {hasImages && <ImageLoader key={realmObjectID} realmObject={realmObject} />}
        </Space>
      );
    case 'right':
      return (
        <Row className="content-wrapper" wrap="true">
          <Col flex={hasImages ? '1 1 50%' : '1 1 100%'} style={{ paddingRight: hasImages ? 16 : 0 }}>
            <StoryPresenter fieldKey={fieldKey} />
          </Col>
           {hasImages && (
            <Col flex="1 1 50%" style={{ textAlign: 'center', paddingRight: 8 }}>
              <ImageLoader key={realmObjectID} realmObject={realmObject} style={{ width: '100%', height: 'auto' }} />
            </Col>
          )}
        </Row>
      );
    case 'left':
    default:
      return (
       <Row className="content-wrapper" wrap={false}>
          {hasImages && (
            <Col flex="1 1 50%" style={{ textAlign: 'center', paddingRight: 8 }}>
              <ImageLoader key={realmObjectID} realmObject={realmObject} style={{ width: '100%', height: 'auto' }} />
            </Col>
          )}
          <Col flex={hasImages ? '1 1 50%' : '1 1 100%'} style={{ paddingLeft: hasImages ? 8 : 0 }}>
            <StoryPresenter fieldKey={fieldKey} />
          </Col>
        </Row>
      );
  }
}

export default StoryWithImage;
